export default __webpack_public_path__ + "static/media/ecom.13acfbc0.svg";